// Per-browser-session guard so a successful login is recorded at most once per
// user, even across page refreshes (a refresh re-mounts the app but keeps
// sessionStorage). All access is best-effort — telemetry must never break the
// login UX.

const STORAGE_KEY = 'recordedLoginUserIds';

function readRecordedLoginUserIds(): string[] {
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    const ids = raw ? JSON.parse(raw) : [];
    return Array.isArray(ids) ? (ids as string[]) : [];
  } catch {
    return [];
  }
}

export function hasRecordedLoginThisSession(userId: string): boolean {
  return readRecordedLoginUserIds().includes(userId);
}

export function markLoginRecordedThisSession(userId: string): void {
  try {
    const ids = readRecordedLoginUserIds();
    if (!ids.includes(userId)) {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify([...ids, userId]));
    }
  } catch {
    /* ignore storage errors */
  }
}
